import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import "./Search.scss";
import useFetch from "../../../hooks/useFetch";
import { useNavigate } from "react-router-dom";

import { urlFor, client } from '../../../lib/client';

const Search = ({ setSearchModal }) => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const onChange = (e) => {
    setQuery(e.target.value);
  };

  const [products, setProducts] = useState([]);
  console.log(products)

  useEffect(() => {
    // Only fetch products when there's a search query
    if (query) {
      const searchQuery = `*[_type == "product" && name match "${query}*" ]`;
      client.fetch(searchQuery).then((data) => {
        setProducts(data);
      });
    }
  }, [query]);

  // Filter products based on search query
  const filteredProducts = products.filter((item) =>
    item?.name?.toLowerCase().includes(query.toLowerCase())
  );
  console.log(filteredProducts)

  useEffect(() => {
    // Clear products array when the search bar is cleared
    if (query === "") {
      setProducts([]);
    }
  }, [query]);

  return (
    <div className="search-modal">
      <div className="form-field">
        <input
          autoFocus
          type="text"
          placeholder="Search for products"
          value={query}
          onChange={onChange}
        />
        <MdClose
          className="close-btn"
          onClick={() => setSearchModal(false)}
        />
      </div>
      <div className="search-result-content">
        {query !== "" && !filteredProducts.length && (
          <div className="start-msg">
            No matching products found.
          </div>
        )}
        {query === "" && (
          <div className="start-msg">
            Start typing to see products you are looking for.
          </div>
        )}
        <div className="search-results">
          {filteredProducts.map((item) => (
            <div
              className="search-result-item"
              key={item._id}
              onClick={() => {
                navigate("/product/" + item._id);
                setSearchModal(false);
              }}
            >
              <div className="image-container">
                <img src={urlFor(item?.image[0])} alt={item?.brand} />
              </div>
              <div className="prod-details">
                <span className="name">{item.title}</span>
                <span className="desc">{item.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Search;